import { useState, useRef } from 'react';
import { useImportResults, useDeleteAllResults } from '@/hooks/useResults';

export const useResultsActions = (selectedRaceId: string) => {
  const importMutation = useImportResults(selectedRaceId);
  const deleteAllMutation = useDeleteAllResults(selectedRaceId);

  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState<any>(null);
  const [pasteValue, setPasteValue] = useState('');
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImport = async (jsonString: string) => {
    if (!selectedRaceId || !jsonString) return;
    setImporting(true);
    setImportResult(null);
    try {
      const res = await importMutation.mutateAsync(jsonString);
      setImportResult(res);
    } catch (err: any) {
      setImportResult({ error: err.response?.data || err.message });
    }
    setImporting(false);
  };

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files: File[] = Array.from(e.target.files || []);
    for (const file of files) {
      const text = await file.text();
      await handleImport(text);
    }
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const handlePasteImport = () => {
    if (pasteValue.trim()) {
      handleImport(pasteValue.trim());
      setPasteValue('');
    }
  };

  const handleClearAll = async () => {
    if (!selectedRaceId) return;
    await deleteAllMutation.mutateAsync();
  };

  return {
    importing, importResult, setImportResult,
    pasteValue, setPasteValue,
    fileInputRef,
    handleFileUpload, handlePasteImport, handleClearAll,
  };
};
